import { render, staticRenderFns } from "./insertCompany.vue?vue&type=template&id=ae33220a&scoped=true&"
import script from "./insertCompany.vue?vue&type=script&lang=js&"
export * from "./insertCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae33220a",
  null
  
)

export default component.exports